<script>
import * as _ from 'lodash'
export default {
  model: {
    event: 'update',
  },
  props: {
    questionId: { type: Number, required: true },
    questionTitle: { type: String, required: true },
    questionOptions: { type: Object, required: true },
    questionType: { type: String, required: true },
    selected: { type: null, required: true },
  },
  data() {
    return {
      radioGroup: 1,
      radioAns: _.cloneDeep(this.selected),
    }
  },
  watch: {
    selected(newValue) {
      if (_.isEmpty(newValue)) {
        this.radioAns = []
      }
    },

    radioAns(newValue) {
      if (newValue.length) {
        const val = this.questionOptions[newValue]
        this.$emit('update', Object.fromEntries([[newValue, val]]))
      }
    },
  },
}
</script>

<template>
  <div :class="$style.radioWrapp">
    <h3 :class="$style.question">{{ questionTitle }}<sup>*</sup></h3>
    <ul :class="$style.questionOptionList">
      <li v-for="(options, key) in questionOptions" :key="key">
        <v-radio-group v-model="radioAns">
          <v-radio :label="options" :value="key"></v-radio>
        </v-radio-group>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.question {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
}
.question sup {
  color: #f00;
}
.questionOptionList {
  padding: 0 !important;
  margin: 0;
  list-style: none;
}
.questionOptionList li {
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  color: #09101d;
}
.radioWrapp {
  margin-block: 10px;
}
</style>

<style scoped>
/deep/ .v-input--selection-controls .v-radio > .v-label {
  color: #000;
}
</style>
